export default "__VITE_ASSET__CQsrlrQm__"